import * as React from "react";

// Import styles
import "./styles/forAgenciesForm.scss";

// Bootstrap imports
import { Button, Col, Container, Form, Row } from "react-bootstrap";

const ForAgenciesForm = (props) => {
  return (
    <div className="for-agencies-form">
      <Container>
        <h2 className="shout fade-in-slow">
          {props.data.forAgenciesFields.forAgenciesForm.title}
        </h2>
        <p className="talk fade-in-slow">
          {props.data.forAgenciesFields.forAgenciesForm.paragraph}
        </p>
        <div className="form fade-in-slow">
          <form
            id="contact"
            name="For Agencies"
            method="POST"
            data-netlify="true"
            action="/thank-you"
          >
            <input type="hidden" name="form-name" value="For Agencies" />
            <Row>
              <Col xs={12} md={6}>
                <label>
                  Name
                  <input
                    type="text"
                    name="Name"
                    placeHolder="Enter your name."
                  />
                </label>
                <label>
                  Agency Name
                  <input
                    type="text"
                    name="Agency Name"
                    placeHolder="Enter ythe name of your agency."
                  />
                </label>
              </Col>
              <Col xs={12} md={6}>
                <label>
                  Agency Email Address
                  <input
                    type="email"
                    name="Agency Email"
                    placeHolder="Enter your email."
                  />
                </label>
                <label>
                  Agency Website
                  <input
                    type="text"
                    name="Agency Website"
                    placeHolder="Enter your website url."
                  />
                </label>
              </Col>
              <Col xs={12}>
                <label>
                  Message
                  <textarea
                    name="Message"
                    placeHolder="Type us a message."
                  ></textarea>
                </label>
              </Col>
              <Col className="submit-button">
                <button className="btn btn-accent" type="submit">
                  Submit
                </button>
              </Col>
            </Row>
          </form>
        </div>
      </Container>
    </div>
  );
};

export default ForAgenciesForm;
